import PropTypes from "prop-types";

export const HoneypotInput = ({ name, type = "text" }) => {
  return (
    <input
      type={type}
      name={name}
      style={{ display: "none" }}
      tabIndex={-1}
      autoComplete="off"
    />
  );
};

HoneypotInput.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
};
